// Utils
import classnames from 'classnames'

import RangeSlider from '../RangeSlider'
import { FillRangeItemProps } from '../fillRangeItem'

import styles from './productReviewSummaryRangeSlider.module.scss'

interface ProductReviewSummaryRangeSliderProps {
  ranges: FillRangeItemProps[]
  className?: string
}

export const ProductReviewSummaryRangeSlider = ({ ranges, className = '' }: ProductReviewSummaryRangeSliderProps) => {
  const wrapClasses = classnames(styles.reviewRangeSliderContainer, className)
  return (
    <div className={wrapClasses}>
      {ranges.map(range => {
        return (
          <RangeSlider
            key={range.title}
            percentage={range.fillPercentage || 0}
            title={range.title || ''}
            maxLabel={range.maxLabel}
            minLabel={range.minLabel}
            className={styles.reviewRangeSliderContainer__reviewRangeSlider}
            wrapperClassName={styles.reviewRangeSliderContainer__reviewRangeSliderWrapper}
          />
        )
      })}
    </div>
  )
}

export default ProductReviewSummaryRangeSlider
